import { COVERGO_SAAS_DEV, COVERGO_ASIA_PRE_PROD, COVERGO_ASIA_UAT, COVERGO_SAAS_PROD, COVERGO_ASIA_NFR } from "../consts.js"

export const asiaeb = {
	"asia-health-dev-studio.quote.hk": {
		appConfig: {
			tenantId: "asia_dev",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV,
	},
	"asia-studio.preprod.asia.covergo.cloud": {
		appConfig: {
			tenantId: "asia_preprod",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_PRE_PROD,
	},
	"asia-studio.uat.asia.covergo.cloud": {
		appConfig: {
			tenantId: "asia_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_UAT,
	},
	"asia-studio.asia.covergo.com": {
		appConfig: {
			tenantId: "asia_prod",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_PROD,
	},
	"asia-studio.nfr.covergo.cloud": {
		appConfig: {
			tenantId: "asia_nfr",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_NFR,
	},
	"asia-test-studio.preprod.asia.covergo.cloud": {
		appConfig: {
			tenantId: "asia_test",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_PRE_PROD,
	},
}
